/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_Types_Proximity_DescriptionInputs */

const es_billing_alerts_types_proximity_description = /** @type {(inputs: Billing_Alerts_Types_Proximity_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se enviará una notificación cuando alcances el 90% del monto configurado.`)
};

const en_billing_alerts_types_proximity_description = /** @type {(inputs: Billing_Alerts_Types_Proximity_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A notification will be sent when you reach 90% of the configured amount.`)
};

/**
* | output |
* | --- |
* | "A notification will be sent when you reach 90% of the configured amount." |
*
* @param {Billing_Alerts_Types_Proximity_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_types_proximity_description = /** @type {((inputs?: Billing_Alerts_Types_Proximity_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_Types_Proximity_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_types_proximity_description(inputs)
	return en_billing_alerts_types_proximity_description(inputs)
});
export { billing_alerts_types_proximity_description as "billing.alerts.types.proximity.description" }